// React Thirty Party Library
import { Form, Col, DatePicker, TreeSelect } from "antd";
import { useSelector } from "react-redux";

// Constants Library

// Components Library

// Redux Library
import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util";

// Styles Library
 
const { reduxStoreWrapper } = REDUX_UTIL
const { todayStart, todayEnd } = TIME

const treeDVCData = (dvc) => ([{
    title: 'All',
    key: 'All',
    value: 'All',
    children: Object.values(dvc).map((v) => ({
        title: v.dvid?.split('#')[1],  
        key: v.dvid, 
        value: v.dvid,  
    }))
}])

const DeviceSearchField = ({ form }) => { 

const devices = useSelector(reduxStoreWrapper("devices.staticsByID"));

const dvcOptions = treeDVCData(devices)

    return (
        <>
            <Col className = "formField report">
                <Form.Item name="dvids" rules={[{ required: true }]}>
                    <span className = "formFieldLabel">Devices: </span>
                    <TreeSelect
                        treeData={dvcOptions}
                        treeCheckable
                        showCheckedStrategy={TreeSelect.SHOW_PARENT}
                        placeholder = {Object.keys(devices).length ? 'Select Devices' : "No Devices Found"}
                        disabled = {!Object.keys(devices).length}
                        style={{ width: '240px', maxHeight: 30, overflowY: 'auto', height: 30 }}
                        onChange={(value) => form.setFieldsValue({ dvids: value })}
                    />
                </Form.Item>
            </Col> 

            <Col className = "formField">
                <Form.Item name="timeframe" rules={[{ required: true }]}>
                    <span className = "formFieldLabel">Timeframe: </span>
                    <DatePicker.RangePicker 
                        showTime
                        format="YYYY-MM-DD HH:mm"
                        defaultValue={[todayStart, todayEnd]} 
                        onChange={e => form.setFieldsValue({ timeframe: e })} 
                    />
                </Form.Item>
            </Col>
        </>
    );
};

export default DeviceSearchField;